<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>员工管理</el-breadcrumb-item>
      <el-breadcrumb-item>智能绩效</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            @node-click="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div>
        <el-table :data="userList" fit border stripe="stripe"
                  height="600px" :cell-style="{padding: '5px'}"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}"
                  @row-click="selectUser">
          <el-table-column
            align="center"
            prop="userName"
            label="员工名称" width="100px">
          </el-table-column>
        </el-table>
      </div>
      <div style="rgb(222,222,222);width: 100%;height: 600px;background-color: #eff3f8">
        <el-button size="mini"  @click="showShopPerfRuleDialog">添加一行</el-button>
        <div style="display: flex;justify-content: center">
          <span style="color: #f78989;font-size: 14px">当前正在为·
            <span style="color: #38ac22;font-size: 14px">{{selectedUser.userName}}·</span>添加绩效</span>
        </div>
        <el-form>
          <el-table :data="selectedShopPerfRuleList" fit border stripe="stripe"
                    :cell-style="{padding: '5px'}"
                    :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                    :row-style="{height: '0'}">
            <el-table-column
              align="center"
              label="操作" >
              <template slot-scope="scope">
                <el-link type="danger" icon="el-icon-delete"
                         @click="deleteRow(scope.row, scope.$index)"></el-link>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="perfTypeCn"
              label="绩效类目" >
            </el-table-column>
            <el-table-column
              align="center"
              label="内容明细" >
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>{{ scope.row.content }}</p>
                  <div slot="reference" class="name-wrapper">
                    <el-tag size="mini">{{ scope.row.content }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="awardTypeCn"
              label="奖励方式">
            </el-table-column>
            <el-table-column
              align="center"
              prop="awardValue"
              label="奖励数额">
            </el-table-column>
            <el-table-column
              align="center"
              prop="addScore"
              label="加分" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="cheFaTypeCn"
              label="惩罚方式" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="cheFaValue"
              label="惩罚数额" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="subScore"
              label="减分" >
            </el-table-column>
          </el-table>
        </el-form>
        <el-button size="mini" @click="createUserPerfRule">创建</el-button>
      </div>
      <el-dialog
        title="绩效规则列表"
        :visible.sync="shopPerfRuleDialogVisible"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-table :data="shopPerfRuleList" fit border stripe="stripe"
                  height="300px" :cell-style="{padding: '5px'}"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="160">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="selectPerfRuleId"
                        @change.native="selectShopPerfRule(scope.row)">{{''}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="perfTypeCn"
            label="绩效类目" >
          </el-table-column>
          <el-table-column
            align="center"
            label="内容明细" >
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ scope.row.content }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="mini">{{ scope.row.content }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="awardTypeCn"
            label="奖励方式">
          </el-table-column>
          <el-table-column
            align="center"
            prop="awardValue"
            label="奖励数额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="addScore"
            label="加分" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="cheFaTypeCn"
            label="惩罚方式" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="cheFaValue"
            label="惩罚数额" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="subScore"
            label="减分" >
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      orgId: '',
      userId: '',
      orgList: [],
      userList: [],
      selectUserId: '',
      selectedUser: '',
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      shopPerfRuleDialogVisible:false,
      shopPerfRuleList:[],
      selectedShopPerfRuleList:[],
      selectPerfRuleId:'',
      selectedShopPerfRule:'',
      userPerfRule:{
        shopPerfRuleList:[],
        userId:'',
        shopId:'',
        creator:'',
      }
    }
  },
  methods:{
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //组织机构树点击节点方法
    handleCheckChange(data) {
      this.selectOrgId = data.id;
      this.selectUserId = '';
      if (data.id === 1){
        this.$message.warning("集团的员工请选择集团指挥部！")
        return;
      }
      this.loadUser(data.id);
      this.loadShopPerfRule();
    },
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    async loadUser(data){
      if (data !== ''){
        const {data:res} = await this.$http.get(`/org/users/${data}`);
        this.userList = res.data;
      }
    },
    async selectUser(row){
      this.selectedUser = row;
    },
    async loadShopPerfRule(){
        const {data:res} = await this.$http.get(`/load/shop/perf/rule/${this.selectOrgId}`);
        this.shopPerfRuleList = res.data;
    },
    showShopPerfRuleDialog(){
      this.selectPerfRuleId = '';
      this.shopPerfRuleDialogVisible = true;
    },
    closeShopPerfRuleDialog(){
      this.shopPerfRuleDialogVisible = false;
    },
    selectShopPerfRule(row){
      this.selectedShopPerfRule = row;
      if (!this.selectedShopPerfRuleList.includes(row)){
        this.selectedShopPerfRuleList.push(row);
      }
      this.closeShopPerfRuleDialog();
    },
    deleteRow(row, index){
      this.selectedShopPerfRuleList.splice(index, 1);
    },
    async createUserPerfRule(){
      if (this.selectedUser === ''){
        return this.$message.warning("请选择员工");
      }
      if (this.selectedShopPerfRuleList.length == 0){
        return this.$message.warning("请添加绩效明细");
      }
      this.userPerfRule.userId = this.selectedUser.id;
      this.userPerfRule.shopPerfRuleList = this.selectedShopPerfRuleList;
      this.userPerfRule.shopId = this.selectOrgId;
      this.userPerfRule.creator = this.userId;
      const {data:res} = await this.$http.post(`/new/user/perf/rule`, this.userPerfRule);
      if (res.code === 200){
        this.$message.success("操作成功")
      }
      this.clear();
    },
    clear(){
      this.selectPerfRuleId = '';
      this.selectedShopPerfRule = '';
      this.selectedShopPerfRuleList = [];
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/UserPerfRule.vue